import React, { useState, useEffect } from 'react';
import './employeedashboard.css'; // Ensure the CSS is applied

import LeavePortal from './Leaveportal'; // Correct import for LeavePortal component
import TaskUpdateForm from './Taskupdate'; // Correct import for TaskUpdateForm component

function EmployeeDashboard() {
  // State to store employee details
  const [empId, setEmpId] = useState('');
  const [empName, setEmpName] = useState('');
  const [designation, setDesignation] = useState('');

  useEffect(() => {
    // Retrieve data from localStorage
    const storedEmpId = localStorage.getItem('empId');
    const storedEmpName = localStorage.getItem('empName');
    const storedDesignation = localStorage.getItem('designation');
    
    // Debugging to check values in localStorage
    console.log('Stored EmpName:', storedEmpName);
    console.log('Stored EmpId:', storedEmpId);
    console.log('Stored Designation:', storedDesignation);

    // If values exist in localStorage, set them to state
    if (storedEmpId && storedEmpName && storedDesignation) {
      setEmpId(storedEmpId);
      setEmpName(storedEmpName);
      setDesignation(storedDesignation);
    } else {
      console.error('Employee details not found in localStorage');
    }
  }, []); // Empty array ensures this runs only once on component mount

  return (
    <div >
      {/* Conditional Rendering of Welcome Message */}
      {empName ? (
        <div className="welcome-message">
          <p>Welcome, {empName}!</p>
        </div>
      ) : (
        <div className="welcome-message">
          <p>Welcome, User!</p>
        </div>
      )}
      <div className="employee-dashboard-container">

      </div>

      {/* Main container for both components */}
      <div className="employee-dashboard-main-container">
        {/* Leave Portal Section */}
        <LeavePortal />
        
        {/* Task Update Form Section */}
        <TaskUpdateForm />
      </div>
    </div>
  );
}

export default EmployeeDashboard;






